import { useSearchParams } from 'react-router';
import { lowerCamelStringToSnake } from './python-converter';

export const getSortOrder = (
  sortingKey: string,
  ordering: string | null,
): 'ascend' | 'descend' | null => {
  if (!ordering) {
    return null;
  }
  const convertedSortingKey = lowerCamelStringToSnake(sortingKey);
  if (convertedSortingKey === ordering) {
    return 'ascend';
  }
  if (`-${convertedSortingKey}` === ordering) {
    return 'descend';
  }
  return null;
};

export const useGetSortOrder = (orderingKey = 'ordering') => {
  const [searchParams] = useSearchParams();
  const ordering = searchParams.get(orderingKey);
  return (sortingKey: string) => getSortOrder(sortingKey, ordering);
};
